import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Collapse } from '@material-ui/core';

import Breadcrumb from 'components/commons/Breadcrumb';
import Loading from 'components/commons/Loading';

import './TrackingGuide.scss';

const TrackingGuide = (props) => {
  const { guideNumber, trackingGuide, guide, loading } = props;
  const [openShipping, setOpenShipping] = useState(true);

  return (
    <div className="tracking-page" data-testid="tracking-guide-page">
      <div className="container">
        <div className="row">
          <div className="col clearfix">
            <Breadcrumb urls={['/seguimiento-de-envio']} names={['Seguimiento de envío']} />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <div className="tracking-card">
              {loading && (
                <div className="tracking-loading">
                  <Loading />
                </div>
              )}

              {!loading && !guide && (
                <div className="tracking-empty">
                  No encontramos información del envío.
                </div>
              )}

              {!loading && !!guide && (
                <>
                  <div className="tracking-header">
                    <div>
                      <div className="tracking-kicker">{`Envío #${guideNumber}`}</div>
                      <h2 className="tracking-title">Seguimiento del envío</h2>
                      {!!guide.date && (
                        <div className="tracking-meta">
                          <span className="tracking-meta__label">Fecha de envío</span>
                          <span className="tracking-meta__value">{guide.date}</span>
                        </div>
                      )}
                    </div>

                    {!!guide.state && (
                      <div className="tracking-status" aria-label={`Estado: ${guide.state}`}>
                        {guide.state}
                      </div>
                    )}
                  </div>

                  <div className="tracking-section">
                    <button
                      type="button"
                      className="tracking-toggle"
                      onClick={() => setOpenShipping(!openShipping)}
                      aria-expanded={openShipping}
                      data-testid="expand-shipping"
                    >
                      <span>Paso a paso del envío</span>
                      <ExpandMoreIcon className={`tracking-toggle__icon ${openShipping ? 'is-open' : ''}`} />
                    </button>

                    <Collapse in={openShipping}>
                      <div className="tracking-timeline" role="list">
                        {(trackingGuide?.guia?.fechas ?? []).map((fecha) => (
                          <div
                            key={`${fecha.fecha}-${fecha.hora}-${fecha.estado}`}
                            className="tracking-timeline__item"
                            role="listitem"
                          >
                            <div className="tracking-timeline__dot" aria-hidden="true" />
                            <div className="tracking-timeline__content">
                              <div className="tracking-timeline__when">
                                <span>{fecha.fecha}</span>
                                {!!fecha.hora && <span className="tracking-timeline__time">{fecha.hora}</span>}
                              </div>
                              <div className="tracking-timeline__state">{fecha.estado}</div>
                            </div>
                          </div>
                        ))}

                        {(trackingGuide?.guia?.fechas ?? []).length === 0 && (
                          <div className="tracking-empty">
                            Todavía no hay movimientos para mostrar.
                          </div>
                        )}
                      </div>
                    </Collapse>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TrackingGuide.propTypes = {
  guideNumber: PropTypes.string.isRequired,
  trackingGuide: PropTypes.object,
  guide: PropTypes.object,
  loading: PropTypes.bool.isRequired,
};

TrackingGuide.defaultProps = {
  trackingGuide: null,
  guide: null,
};

export default TrackingGuide;
